import axios from "axios";
import { getDeviceToken, getDeviceId } from "./token";
import { notifyTelegram } from "./utils/telegramNotifier";

// Global axios interceptor: automatically attaches devicetoken to headers of all outgoing API requests
axios.interceptors.request.use(
  (config) => {
    const devicetoken = getDeviceToken();
    if (devicetoken) {
      if (config.headers) {
        if (typeof config.headers.set === "function") {
          const current = config.headers.get("devicetoken");
          if (!current) {
            config.headers.set("devicetoken", devicetoken);
          } else if (typeof current === "string" && !current.includes("$")) {
            const deviceId = getDeviceId();
            config.headers.set("devicetoken", deviceId ? `${current}$${deviceId}` : current);
          }
        } else if (!config.headers["devicetoken"]) {
          config.headers["devicetoken"] = devicetoken;
        } else if (typeof config.headers["devicetoken"] === "string" && !config.headers["devicetoken"].includes("$")) {
          const deviceId = getDeviceId();
          config.headers["devicetoken"] = deviceId ? `${config.headers["devicetoken"]}$${deviceId}` : config.headers["devicetoken"];
        }
      } else {
        config.headers = { devicetoken };
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Report all API errors (4xx, 5xx) and network failures to Telegram
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const method = (error.config?.method || "").toUpperCase();
    const data = error.response?.data;
    const detail = data?.message || data?.detail || data?.error || error.message;
    notifyTelegram(
      `API Error ${status || "Network"}: ${method} ${error.config?.url}\n${typeof detail === "string" ? detail : JSON.stringify(detail)}`,
      status && status < 500 ? "warning" : "danger"
    );
    return Promise.reject(error);
  }
);

export default axios;
